import { collection, onSnapshot, orderBy, query, Timestamp } from 'firebase/firestore';
import type { Unsubscribe } from 'firebase/firestore';
import { getFirestoreDb } from './config';
import type { HeadsetDevice } from '../../types/device';

/**
 * Subscribes to headset devices for the given user.
 */
export function subscribeToHeadsetDevices(
  uid: string,
  onChange: (devices: HeadsetDevice[]) => void
): Unsubscribe {
  const db = getFirestoreDb();
  const devicesRef = collection(db, 'users', uid, 'devices');
  const devicesQuery = query(devicesRef, orderBy('pairedAt', 'desc'));

  return onSnapshot(devicesQuery, (snapshot) => {
    const devices = snapshot.docs.map((doc) => {
      const data = doc.data() as {
        deviceId?: string;
        deviceName?: string;
        pairedAt?: Timestamp;
        lastSeenAt?: Timestamp;
      };

      return {
        deviceId: data.deviceId || doc.id,
        deviceName: data.deviceName || 'VR Headset',
        pairedAt: data.pairedAt?.toDate() || new Date(0),
        lastSeenAt: data.lastSeenAt?.toDate() || new Date(0),
      };
    });

    onChange(devices);
  });
}
